import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  create_service_package,
  delete_service_package,
  fetch_public_service_packages,
  fetch_service_packages,
  update_service_package,
} from './api';
import type { CreateServicePackageInput, PackageModule, UpdateServicePackageInput } from './types';

const PACKAGES_KEY = ['service-packages'] as const;

export function use_service_packages(options?: { enabled?: boolean }) {
  return useQuery({ queryKey: PACKAGES_KEY, queryFn: fetch_service_packages, enabled: options?.enabled ?? true });
}

export function use_public_service_packages(vendor_id: string, module_type?: PackageModule, options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: ['service-packages', 'public', vendor_id, module_type ?? 'all'],
    queryFn: () => fetch_public_service_packages(vendor_id, module_type),
    enabled: options?.enabled ?? true,
  });
}

export function use_create_service_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateServicePackageInput) => create_service_package(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: PACKAGES_KEY }),
  });
}

export function use_update_service_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, input }: { id: string; input: UpdateServicePackageInput }) => update_service_package(id, input),
    onSuccess: () => qc.invalidateQueries({ queryKey: PACKAGES_KEY }),
  });
}

export function use_delete_service_package() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => delete_service_package(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: PACKAGES_KEY }),
  });
}
